import { createFileRoute, Link, Outlet } from "@tanstack/react-router";
import { LayoutGrid } from "lucide-react";

import { ContactId } from "@goose/schema/Salesforce";

import { Breadcrumbs } from "~/components/admin/Breadcrumbs";
import { ContactIcon, OrganizationIcon } from "~/components/admin/Icons";
import { PageHeader } from "~/components/admin/PageHeader";
import { Button } from "~/components/ui/Button";

export const Route = createFileRoute(
  "/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId",
)({
  component: RouteComponent,
  params: {
    parse: ({ contactId }) => {
      return {
        contactId: ContactId.parse(contactId),
      };
    },
  },
});

function RouteComponent() {
  const { organizationId, opportunityId, contactId } = Route.useParams();

  return (
    <div className="space-y-6">
      <PageHeader
        breadcrumbs={
          <Breadcrumbs>
            <Link
              to="/admin/organizations/$organizationId/opportunities/$opportunityId/contacts"
              params={{
                organizationId,
                opportunityId,
              }}
            >
              Contacts
            </Link>
            <span>{contactId}</span>
          </Breadcrumbs>
        }
        icon={ContactIcon}
        title="Contact"
        actions={
          <>
            <Button asChild variant="outline" size="sm">
              <Link
                to="/admin/organizations/$organizationId/contacts/$contactId"
                params={{
                  organizationId,
                  contactId,
                }}
              >
                <OrganizationIcon className="mr-2 h-4 w-4" />
                Organization view
              </Link>
            </Button>
            <Button asChild variant="outline" size="sm">
              <Link
                to="/opportunity/$opportunityId/contact/$contactId"
                params={{
                  opportunityId,
                  contactId,
                }}
              >
                <LayoutGrid className="mr-2 h-4 w-4" />
                View in app
              </Link>
            </Button>
          </>
        }
      />
      <Outlet />
    </div>
  );
}
